import * as React from "react"

function SvgComponent(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="feather feather-bar-chart"
            {...props}
        >
            <path d="M12 20L12 10" />
            <path d="M18 20L18 4" />
            <path d="M6 20L6 16" />
        </svg>
    )
}

export default SvgComponent
